import React from 'react'
import { View, Text, ActionIcon, Icon } from '@/components'
import { createStyles } from '@codeleap/styles'
import { WebInputFile } from '@codeleap/types'

type FilePreviewProps = {
  file: WebInputFile
  onRemove: () => void
}

const Wrapper = ({ children, ...rest }) => (
  <View {...rest} style={styles.filePreviewWrapper}>{children}</View>
)

export const FilePreview = ({ file, onRemove }: FilePreviewProps) => {
  return (
    <FilePreview.Wrapper>
      <View style={['row', 'gap:1', 'center', { maxWidth: '90%' }]}>
        <Icon name='upload-3-line' style={['size:3']} />
        
        <Text
          text={file?.file?.name}
          style={['p3', 'medium', 'ellipsis']}
        />
      </View>
      <ActionIcon 
        name="close-line"
        debugName={'Remove file preview'}
        style={['neutralTerciary', 'iconSize:3', 'normalize']}
        onPress={onRemove}
      />
    </FilePreview.Wrapper>
  )
}

FilePreview.Wrapper = Wrapper

const styles = createStyles(theme => {
  return {
    filePreviewWrapper: {
      ...theme.presets.fullWidth,
      ...theme.presets.row,
      ...theme.presets.justifySpaceBetween,
      ...theme.presets.alignCenter,
      ...theme.spacing.gap(1),
      ...theme.spacing.paddingHorizontal(2),
      cursor: 'pointer',

      height: theme.size['xx-large'],
      ...theme.border({
        color: theme.baseColors.neutralSolid400,
        width: theme.stroke.small,
      }),
      borderRadius: theme.radius.regular,
    }

  }
})